import React from 'react'
import "./style.css"

const Contact = () => {
  return (
    <div className='contact_container'>
      <h2>Contact  Us</h2>

      <p>Email: <a href="">purusarthindustries@gmail.com</a></p>

      <h3>Copy Right Issue</h3>

      <p>
        We own the Intellectual Property Rights (IPR) to a laNajoxGames has a team of 25 people working on our gaming platform.rge number of the games on NajoxGames sites, and for certain games, we requested and obtained licenses from the copyright holders known to us. For some games, we could not find any copyright information, or, due to general use on the internet, this information can no longer be obtained.
      </p>
      <p>
        Some games may be used under special conditions, considering a number of prerequisite constraints. These prerequisite constraints are, as far as we could determine, met by NajoxGames.
      </p>
      <p>
        We do not change anything in the source code of the games. For example, credit holders, brand names, or references to websites remain unchanged. If any copyright or other IPR that you may have is possibly being infringed by/on NajoxGames sites, please inform us immediately, thereby providing us with the following:
      </p>
    </div>
  )
}

export default Contact
